import env from '../../env.json';
import { createBrowserSuperclient } from 'superclient/lib/browser';

export const Superclient = createBrowserSuperclient((env as unknown) as any);
